import { withNamespaces } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
    Col,
    Container,
    Row,
} from 'reactstrap';

import Navigator from "src/components/Navigator";

import Tabs from './components/tabs';
import OverviewDashboard from './tabs-contents/overview';
import EudrDashboard from './tabs-contents/eudr';
import PpwrDashboard from './tabs-contents/ppwr';

const Dashboard = ({
    t,
}) => {
    const location = useLocation();

    const renderSelectedTabContent = () => {
        const searchParams = new URLSearchParams(location.search);

        switch (searchParams.get('tab')) {
            case 'eudr':
                return <EudrDashboard />;

            case 'ppwr':
                return <PpwrDashboard />;

            case 'overview':
            default:
                return <OverviewDashboard />;
        }
    };

    return (
        <div className="page-content supplier-dashboard-page">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator pageTitle={t('Dashboard')} translate={false} />
                    </Col>
                </Row>

                <Row>
                    <Col lg="12" className="mb-4">
                        <div className="details-content-wrapper">
                            <Tabs />

                            <Row>
                                <Col xl="12">
                                    {renderSelectedTabContent()}
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withNamespaces()(Dashboard);
